import HostedMobileLayout from '../../../layouts/MobileLayout';
import HostedActionRow from '../../../components/hosted/ActionRow';
import HostedWaitingScreen from '../shared/WaitingScreen';
import { useBackOrCancel } from '../../../hooks/useBackOrCancel';
import { type WaitingForPresentationPageProps } from '../../../chulak/ChulakSession';

export default function HostedMobileWaitingPage({
  onCancel,
  onBack,
}: WaitingForPresentationPageProps) {
  const backOrCancel = useBackOrCancel(onCancel, onBack);

  return (
    <HostedMobileLayout footer={<HostedActionRow secondary={backOrCancel} />}>
      <HostedWaitingScreen />
    </HostedMobileLayout>
  );
}
